import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('CURRENTUSER_QUESTIONS').plugin(axiosPlugin, {template: "array"});

let fetchCurrentUserQuestionsAction = redux.fetchActionGet();


export const fetchCurrentUserQuestions = (query = {}) => fetchCurrentUserQuestionsAction(`/users/me/my-questions?${queryString.stringify(query)}`);
export const resetCurrentUserQuestions = () => redux.actions.reset();

export const currentUserQuestions = redux.reducer();